<template>
  <!--  第三方SDK说明-->
  <div class='wrapper'>
    <div style='margin-top: 0.18rem'>
      当您使用山东一卡通APP的功能或服务时，在某些特定使用场景下，我司可能会使用具有相应业务资质及能力的第三方服务商提供的软件服务工具包（简称“SDK”）来为您提供服务，由第三方服务商收集您的必要信息。
    </div>
    <div style='margin-top: 0.1rem'>
      请注意，第三方SDK可能因为版本升级、策略调整等原因导致数据类型存在一些变化，附其官方网站链接或相关隐私保护说明链接供参考，具体请以其公示的官方说明为准。
    </div>
    <div style='font-weight: bold;margin: 0.16rem 0'>山东一卡通使用的第三方SDK列表：</div>
    <div class='name'>腾讯位置服务定位SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>用于GPS用户定位、到家业务、售卡业务定位用户位置</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>OAID、系统属性、操作系统及版本、设备型号、运营商基站信息、WIFI信息、传感器信息、蓝牙信息、精确位置信息（GPS信息）</td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android、iOS</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://privacy.qq.com/document/preview/4cf61fd47f584dae83758bb0f11c1533'>
          https://privacy.qq.com/document/preview/4cf61fd47f584dae83758bb0f11c1533</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：Dataprivacy@tencent.com</td>
      </tr>
    </table>

    <div class='name'>友盟+ SDK（推送、统计、基础组件）</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>用于消息推送、统计分析；在集成广点通SDK的基础上，提供广告监测、广告归因、广告效果优化的基本功能</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备信息(IMEI/OAID/MAC/Android ID/IDFA/OpenUDID/GUID/IMSI/ICCID/GAID/SIM序列号/硬件序列号)、位置信息、网络信息、已安装应用列表信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://www.umeng.com/policy'>
          https://www.umeng.com/policy</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>友盟同欣（北京）科技有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：Umeng_Legal@service.umeng.com</td>
      </tr>
    </table>

    <div class='name'>华为推送SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>用于消息推送</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>
          应用基本信息(AppID、推送服务和HMS Core应用版本号、华为推送SDK版本号、应用包名)、应用内设备标识符(AAID和Push
          Token)、设备的硬件信息(设备类型、设备型号)、系统基本信息(系统类型(Android)和系统版本)和系统设置信息(国家码)、地理位置信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177'>
          https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>华为软件技术有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：950800</td>
      </tr>
    </table>

    <div class='name'>小米推送SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>用于向您推送消息</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备标识(OAID、加密的Android
          ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、当前网络类型、WiFi状态、通知栏设置
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://dev.mi.com/console/doc/detail?pId=1822'>
          https://dev.mi.com/console/doc/detail?pId=1822</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>北京小米移动软件有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：400-100-5678</td>
      </tr>
    </table>

    <div class='name'>vivo推送SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>提供推送消息服务、统计推送SDK接口调用成功率</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>应用基本信息(appid、appkey、应用包名、应用版本号、pushSDK版本、已安装应用列表)、应用内设备标识符(vpush的regId、IMEI、ICCID、EMMCID、EMMCID/UFSID
          、OAID/VAID/AAID 、SN码和IMSI、Android ID、移动国家码和vivo
          Android设备的移动网号)、设备的硬件信息(设备类型(如手机，平板等))、系统基本信息(系统类型(如Android，OS等)和系统版本)
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://dev.vivo.com.cn/documentCenter/doc/706'>
          https://dev.vivo.com.cn/documentCenter/doc/706</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>维沃移动通信有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：95033</td>
      </tr>
    </table>

    <div class='name'>OPPO推送SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>提供推送消息服务</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备相关信息(如IMEI或OAID，Serial Number，IMSI，User ID，Android ID，Google Advertising ID,
          手机Region设置，设备型号，手机电量，手机操作系统版本及语言)、应用信息(如APP包名及版本号，运行状态)、推送SDK版本号、网络相关信息(或如IP域名连接结果，当前网络类型)、消息发送结果、通知栏状态(如通知栏权限、用户点击行为)，锁屏状态(如是否锁屏，是否允许锁屏通知)
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://open.oppomobile.com/new/developmentDoc/info?id=10288'>
          https://open.oppomobile.com/new/developmentDoc/info?id=10288</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>广东欢太科技有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：400-199-9666</td>
      </tr>
    </table>

    <div class='name'>科大讯飞SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>接入语音听写功能，将语音转换为文字</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备信息(设备号(IMEI号)、设备码(IMSI码)、IP地址、Android
          ID(安卓唯一设备ID以提供能力授权服务)、中国移动UAID(仅限安卓设备)、OAID(仅限安卓设备)、UUID(仅限iOS设备)、MAC地址(仅限Linux设备))、语音信息、文本信息、运行日志、应用进程信息；
          内置的讯飞移动广告平台SDK组件(com.shu.priory)需要收集设备传感器信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android、iOS</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://www.xfyun.cn/doc/asr/voicedictation/online_iat_sdkprivacy.html'>
          https://www.xfyun.cn/doc/asr/voicedictation/online_iat_sdkprivacy.html</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>科大讯飞股份有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：400-019-9199</td>
      </tr>
    </table>

    <div class='name'>MobSDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>提供社会化分享服务，实现一键分享功能</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备标识符(IMEI号、MAC地址、IDFA广告标识符、SIM卡IMSI信息、OAID/SSID/BSSID)、WiFi信息(WiFi状态、WiFi参数)、已安装应用列表信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://www.mob.com/wiki/detailed?wiki=638&id=14'>
          https://www.mob.com/wiki/detailed?wiki=638&id=14</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>上海掌之淘信息技术有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：021-3350-3213</td>
      </tr>
    </table>

    <div class='name'>微博分享SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>用于实现微博分享功能，将用户选择的图片产品信息分享至微博</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备信息(包括设备型号、设备标识符(如IMEI/AndroidID/IDFA/OPENUDID/GUID/OAID)、设备MAC地址、电信运营商等软硬件特征信息)；用户分享时，获取用户选择的图片或视频
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://open.weibo.com/wiki/Sdk/privacy'>
          https://open.weibo.com/wiki/Sdk/privacy</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>北京微梦创科网络技术有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：400-096-0960</td>
      </tr>
    </table>

    <div class='name'>腾讯Bugly SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>快速定位应用产品问题还原Crash场景</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>
          日志信息(包括Logcat日志以及APP崩溃堆栈信息)、手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a href='https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56'>
          https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>腾讯科技（深圳）有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：Dataprivacy@tencent.com</td>
      </tr>
    </table>

    <div class='name'>阿里移动网关SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>友盟推送SDK因技术需要集成阿里移动网关服务中的Agoo
          SDK组件，以提供消息推送的通道；使用utdid组件，仅在应用本地获取AndroidID标识设备，用来辅助客户端鉴别
        </td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备品牌、型号、联网状态，获取运行中进程信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.J_9220772140.83.6c0f4b54cipacc'>
          http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.J_9220772140.83.6c0f4b54cipacc</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>阿里云计算有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：400-80-13260</td>
      </tr>
    </table>

    <div class='name'>百度语音SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>向您提供语音文本识别服务，用于实现语音识别功能，例如：商户端收款后的语音播报
        </td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备信息(WIFI状态、设备型号、操作系统、BSSID)、音频数据
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://ai.baidu.com/ai-doc/REFERENCE/Qkdykq1r3'>
          https://ai.baidu.com/ai-doc/REFERENCE/Qkdykq1r3</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>北京百度网讯科技有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：400-921-9999</td>
      </tr>
    </table>

    <div class='name'>百度移动统计SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>为帮助开发者使用统计、分析服务，以便开发者了解其最终用户如何使用其移动应用程序；统计最终用户设备中各个移动应用的活跃情况，以便开发者分析并优化其移动应用程序功能和体验
        </td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备信息(IMEI、Android ID、MAC地址、SSID/BSSID)、OAID、WIFI信息、日志信息、运行中进程信息、应用程序列表信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://tongji.baidu.com/web/help/article?id=330&type=0'>
          https://tongji.baidu.com/web/help/article?id=330&type=0</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>北京百度网讯科技有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：ext_tongji_reply@baidu.com</td>
      </tr>
    </table>

    <div class='name'>银联支付SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>帮助用户使用银联支付服务，保障用户账户和网络环境安全稳定，实现网络链路的选择和优化，提升用户体验，收集履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务
        </td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备信息(IMEI号、SSID/BSSID、Wi-Fi状态、Wi-Fi参数)、已安装应用列表信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android、iOS、HarmonyOS</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://user.95516.com/pages/misc/newAgree.html'>
          https://user.95516.com/pages/misc/newAgree.html</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>中国银联股份有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：95516</td>
      </tr>
    </table>

    <div class='name'>腾讯云慧眼人脸核身SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>用于实人实名认证</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>身份证照片或者姓名和身份证号码等身份信息、人脸视频和照片和设备信息(不同版本收集的设备信息有所不同)：<br>
          Android 版将收集内核版本、CPU 信息、机型、系统版本、设备制造商、运营商。<br>
          iOS 版将收集 GUID、蜂窝网络 IP、WIFI IP。
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android、iOS、HarmonyOS</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://privacy.qq.com/document/preview/4661fcc5ceb04a4f878a5874c86b34a2'>
          https://privacy.qq.com/document/preview/4661fcc5ceb04a4f878a5874c86b34a2</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>腾讯云计算（北京）有限责任公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：Dataprivacy@tencent.com</td>
      </tr>
    </table>

    <div class='name'>微信Open SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>用于App拉起并跳转微信小程序相关页面</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备类型、设备型号、设备序列号、WiFi参数（BSSID、SSID）信息、操作系统、已安装应用包名信息
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android、iOS</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8'>
          https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：Dataprivacy@tencent.com</td>
      </tr>
    </table>

    <div class='name'>密码卫士Passguard</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>提供密码登录、支付加密服务</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>无
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android、iOS</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='http://www.microdone.cn/service/post/2749/'>
          http://www.microdone.cn/service/post/2749/</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>北京微通新成网络科技有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>电话：400-610-0688</td>
      </tr>
    </table>

    <div class='name'>淘宝Agoo推送SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>友盟推送SDK因技术需要集成淘宝通道服务中的Agoo SDK组件，以提供消息推送的通道</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>设备识别信息（android ID/IDFA/OPENUDID/GUID）
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao202107141244_11649.html'>
          https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao202107141244_11649.html</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>浙江淘宝网络有限公司、淘宝（中国）软件有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：pipwg@service.alibaba.com</td>
      </tr>
    </table>

    <div class='name'>Quick Tracking SDK</div>
    <table>
      <tr>
        <th>使用目的及场景</th>
        <td>提供统计分析服务</td>
      </tr>
      <tr>
        <th>收集信息范围</th>
        <td>OAID/GAID/MAC/IMEI/Android ID/IDFA/IDFV/OPENUDID/GUID/SIM卡 IMSI信息/硬件序列号/MCC（移动国家编码）、MNC（移动网号）
        </td>
      </tr>
      <tr>
        <th>数据收集方式</th>
        <td>SDK收集并传输信息，不涉及数据共享</td>
      </tr>
      <tr>
        <th>应用客户端</th>
        <td>Android、iOS、HarmonyOS</td>
      </tr>
      <tr>
        <th>隐私政策/官网链接</th>
        <td><a
          href='https://help.aliyun.com/zh/document_detail/467405.html?spm=a2c4g.11186623.help-menu-194063.d_4_0_1.472c4406LboQK3'>
          https://help.aliyun.com/zh/document_detail/467405.html?spm=a2c4g.11186623.help-menu-194063.d_4_0_1.472c4406LboQK3</a>
        </td>
      </tr>
      <tr>
        <th>SDK供应商</th>
        <td>杭州瓴羊智能服务有限公司</td>
      </tr>
      <tr>
        <th>联系方式</th>
        <td>邮箱：lymarketing@lydaas.com</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SdkInfo',
  data() {
    return {}
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped lang='scss'>
.wrapper {
  background-color: white;
  box-sizing: border-box;
  font-size: .15rem;
  text-align: left;
  color: #333333;
  line-height: 1.5;
  padding: 0 .14rem .14rem;

  .name {
    padding: 0.12rem;
    text-align: center;
    background-color: #1E7DFF;
    font-size: 0.14rem;
    font-weight: bold;
    color: white;
  }

  /* 表格边框 */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: .14rem;
  }

  table td,
  table th {
    border: 0.01rem rgba(0, 0, 0, .08) solid;
    padding: .1rem;
    font-size: .14rem;
    vertical-align: middle;
    word-break: break-all;
  }

  table th {
    width: 20%;
    background-color: rgba(0, 0, 0, .03);
  }

  a {
    color: #1E7DFF;
    word-break: break-all;
    text-decoration: underline;
  }
}
</style>
